import { US_STATES } from "@/lib/states";
import { RichTextEditor } from "@/components/RichText";

const field =
  "w-full rounded-xl border border-sbg-raspberry/20 bg-white px-3.5 py-2.5 text-sm text-sbg-burgundy outline-none transition-colors placeholder:text-sbg-burgundy/40 focus:border-sbg-fuchsia";
const lbl = "mb-1.5 block text-sm font-bold text-sbg-burgundy";

export default function ProjectForm({ form, setForm }) {
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div className="space-y-7">
      <div>
        <label className={lbl}>Your Email <span className="text-sbg-fuchsia">*</span></label>
        <input
          type="email"
          data-testid="form-email"
          value={form.email}
          onChange={set("email")}
          placeholder="you@example.com"
          className={field}
        />
        <p className="mt-1 text-xs text-sbg-burgundy/60">
          We'll email you your frame, page link and press release — and you can sign in with this email to edit later.
        </p>
      </div>

      <div>
        <label className={lbl}>Your Age (Optional)</label>
        <input type="number" min="1" max="120" inputMode="numeric" data-testid="form-age" value={form.age || ""} onChange={set("age")} placeholder="16" className={field + " sm:max-w-[140px]"} />
      </div>

      <div className="grid gap-5 sm:grid-cols-2">
        <div>
          <label className={lbl}>Project Name</label>
          <input data-testid="form-project-title" value={form.project_title} onChange={set("project_title")} placeholder="My Joy Project" className={field} />
        </div>
        <div>
          <label className={lbl}>Your Instagram (Optional)</label>
          <input data-testid="form-instagram" value={form.instagram} onChange={set("instagram")} placeholder="@yourhandle" className={field} />
        </div>
      </div>

      <div>
        <label className={lbl}>What Does Your Project Do?</label>
        <RichTextEditor
          testId="form-description"
          value={form.project_description}
          onChange={(html) => setForm((f) => ({ ...f, project_description: html }))}
          placeholder="Finish the sentence: My project..."
          minRows={4}
        />
        <p className="mt-1 text-xs text-sbg-burgundy/50">Use bold, italics or bullet points to make it pop.</p>
      </div>

      <div className="grid gap-5 sm:grid-cols-2">
        <div>
          <label className={lbl}>Who Will It Serve? (Optional)</label>
          <input data-testid="form-serves" value={form.project_serves} onChange={set("project_serves")} placeholder="Girls in my city" className={field} />
        </div>
        <div>
          <label className={lbl}>When Will It Happen? (Optional)</label>
          <input data-testid="form-when" value={form.project_when} onChange={set("project_when")} placeholder="This fall" className={field} />
        </div>
      </div>

      <div className="grid gap-5 sm:grid-cols-2">
        <div>
          <label className={lbl}>City Or Community</label>
          <input data-testid="form-city" value={form.city} onChange={set("city")} placeholder="Selma" className={field} />
        </div>
        <div>
          <label className={lbl}>State</label>
          <select data-testid="form-state" value={form.state} onChange={set("state")} className={field}>
            <option value="">Choose a state</option>
            {US_STATES.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>
      </div>

      <div>
        <label className={lbl}>Why Does Joy Matter To You?</label>
        <textarea
          data-testid="form-quote"
          value={form.quote}
          onChange={set("quote")}
          rows={2}
          placeholder="A sentence or two in your own words. This becomes your quote."
          className={field}
        />
      </div>

      <div className="rounded-2xl border border-pt-lavender/40 bg-pt-lavender/10 p-5">
        <h4 className="text-sm font-bold text-pt-purple">Media contact (press release only — never shown on your page)</h4>
        <p className="mt-1 text-xs text-pt-purple/70">Under 18? Use a parent or guardian as your media contact.</p>
        <div className="mt-4 grid gap-4 sm:grid-cols-3">
          <input data-testid="form-mc-name" value={form.media_contact_name} onChange={set("media_contact_name")} placeholder="Contact name" className={field} />
          <input data-testid="form-mc-email" value={form.media_contact_email} onChange={set("media_contact_email")} placeholder="Contact email" className={field} />
          <input data-testid="form-mc-phone" value={form.media_contact_phone} onChange={set("media_contact_phone")} placeholder="Phone" className={field} />
        </div>
      </div>

      <label data-testid="form-gallery-optin-label" className="flex cursor-pointer items-start gap-3 rounded-2xl border border-sbg-raspberry/15 bg-white p-5">
        <input type="checkbox" data-testid="form-gallery-optin" checked={!!form.gallery_opt_in}
          onChange={(e) => setForm((f) => ({ ...f, gallery_opt_in: e.target.checked }))}
          className="mt-0.5 h-5 w-5 shrink-0 accent-sbg-fuchsia" />
        <span>
          <span className="block text-sm font-bold text-sbg-burgundy">Show my page in the Winner Gallery</span>
          <span className="mt-1 block text-xs text-sbg-burgundy/70">
            Yes, Southern Black Girls may feature my frame and project on the public #BlackGirlJoyChallenge Winner Gallery. You can change this anytime after signing in.
          </span>
        </span>
      </label>
    </div>
  );
}
